// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    stock: {
      label: 'Existencias',
      help: 'Una fila por material, tal como está HOY. No tiene historia: para un mes, usa los movimientos',
    },
    movements: {
      label: 'Movimientos de almacén',
      help: 'Una fila por movimiento. Es el conjunto que sabe qué pasó en cada mes',
    },
    dates: {
      created: 'Fecha de alta del material',
      at: 'Fecha del movimiento',
    },
    metrics: {
      value: 'Valor del stock',
      materials: 'Materiales',
      units: 'Unidades',
      belowMinimum: 'Bajo mínimo',
      outOfStock: 'Sin existencias',
      saleValue: 'Valor a precio de venta',
      leadTime: 'Plazo de reposición',
      consumed: 'Material consumido',
      movements: 'Movimientos',
      in: 'Entradas',
      out: 'Salidas',
      adjusted: 'Regularizado',
      quantity: 'Unidades movidas',
      movedValue: 'Valor movido',
      unitCost: 'Coste unitario medio',
    },
    dimensions: {
      category: 'Familia',
      unit: 'Unidad de medida',
      supplier: 'Proveedor habitual',
      belowMinimum: 'Bajo mínimo',
      tag: 'Etiqueta',
      material: 'Material',
      kind: 'Tipo de movimiento',
      from: 'Desde',
      to: 'Hasta',
      user: 'Quién lo movió',
      reason: 'Motivo',
    },
    filters: {
      stock: 'Unidades en stock',
      cost: 'Coste unitario',
      leadTime: 'Días de reposición',
      quantity: 'Cantidad',
      code: 'Código del material',
    },
  },
  ca: {
    stock: {
      label: 'Existències',
      help: 'Una fila per material, tal com està AVUI. No té història: per a un mes, fes servir els moviments',
    },
    movements: {
      label: 'Moviments de magatzem',
      help: 'Una fila per moviment. És el conjunt que sap què va passar cada mes',
    },
    dates: {
      created: 'Data d\'alta del material',
      at: 'Data del moviment',
    },
    metrics: {
      value: 'Valor de l\'estoc',
      materials: 'Materials',
      units: 'Unitats',
      belowMinimum: 'Sota mínim',
      outOfStock: 'Sense existències',
      saleValue: 'Valor a preu de venda',
      leadTime: 'Termini de reposició',
      consumed: 'Material consumit',
      movements: 'Moviments',
      in: 'Entrades',
      out: 'Sortides',
      adjusted: 'Regularitzat',
      quantity: 'Unitats mogudes',
      movedValue: 'Valor mogut',
      unitCost: 'Cost unitari mitjà',
    },
    dimensions: {
      category: 'Família',
      unit: 'Unitat de mesura',
      supplier: 'Proveïdor habitual',
      belowMinimum: 'Sota mínim',
      tag: 'Etiqueta',
      material: 'Material',
      kind: 'Tipus de moviment',
      from: 'Des de',
      to: 'Fins a',
      user: 'Qui ho va moure',
      reason: 'Motiu',
    },
    filters: {
      stock: 'Unitats en estoc',
      cost: 'Cost unitari',
      leadTime: 'Dies de reposició',
      quantity: 'Quantitat',
      code: 'Codi del material',
    },
  },
  en: {
    stock: {
      label: 'Stock',
      help: 'One row per material, AS IT IS TODAY. It has no history: for a month, use the movements',
    },
    movements: {
      label: 'Stock movements',
      help: 'One row per movement. The dataset that knows what happened in each month',
    },
    dates: {
      created: 'Material created',
      at: 'Movement date',
    },
    metrics: {
      value: 'Stock value',
      materials: 'Materials',
      units: 'Units',
      belowMinimum: 'Below minimum',
      outOfStock: 'Out of stock',
      saleValue: 'Value at sale price',
      leadTime: 'Lead time',
      consumed: 'Material consumed',
      movements: 'Movements',
      in: 'In',
      out: 'Out',
      adjusted: 'Adjusted',
      quantity: 'Units moved',
      movedValue: 'Value moved',
      unitCost: 'Average unit cost',
    },
    dimensions: {
      category: 'Category',
      unit: 'Unit of measure',
      supplier: 'Usual supplier',
      belowMinimum: 'Below minimum',
      tag: 'Tag',
      material: 'Material',
      kind: 'Movement kind',
      from: 'From',
      to: 'To',
      user: 'Moved by',
      reason: 'Reason',
    },
    filters: {
      stock: 'Units in stock',
      cost: 'Unit cost',
      leadTime: 'Days to replace',
      quantity: 'Quantity',
      code: 'Material code',
    },
  },
  fr: {
    stock: {
      label: 'Stock',
      help: 'Une ligne par matériau, TEL QU\'IL EST AUJOURD\'HUI. Sans historique : pour un mois, utilisez les mouvements',
    },
    movements: {
      label: 'Mouvements de stock',
      help: 'Une ligne par mouvement. Le jeu de données qui sait ce qui s\'est passé chaque mois',
    },
    dates: {
      created: 'Création du matériau',
      at: 'Date du mouvement',
    },
    metrics: {
      value: 'Valeur du stock',
      materials: 'Matériaux',
      units: 'Unités',
      belowMinimum: 'Sous le minimum',
      outOfStock: 'En rupture',
      saleValue: 'Valeur au prix de vente',
      leadTime: 'Délai de réapprovisionnement',
      consumed: 'Matériau consommé',
      movements: 'Mouvements',
      in: 'Entrées',
      out: 'Sorties',
      adjusted: 'Régularisé',
      quantity: 'Unités déplacées',
      movedValue: 'Valeur déplacée',
      unitCost: 'Coût unitaire moyen',
    },
    dimensions: {
      category: 'Famille',
      unit: 'Unité de mesure',
      supplier: 'Fournisseur habituel',
      belowMinimum: 'Sous le minimum',
      tag: 'Étiquette',
      material: 'Matériau',
      kind: 'Type de mouvement',
      from: 'Depuis',
      to: 'Vers',
      user: 'Déplacé par',
      reason: 'Motif',
    },
    filters: {
      stock: 'Unités en stock',
      cost: 'Coût unitaire',
      leadTime: 'Jours de réapprovisionnement',
      quantity: 'Quantité',
      code: 'Code du matériau',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
